import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isChatModal: false,
  isProductInfo: {},
  campaignInfoForChat: {},
  allowChat: false,
  isProductChat: false,
  isBuyerChatHistory: {},
  clearedCampaigns: {},
  clearedProducts: {},
  isSelectedCampaignProductsChat: {},
};

const chatCommunicationHandleSlice = createSlice({
  name: "chatCommunicationSlice",
  initialState,
  reducers: {
    setIsChatModal: (state, action) => {
      state.isChatModal = action.payload;
    },
    setIsProductInfo: (state, action) => {
      state.isProductInfo = action.payload;
    },
    setCampaignInfoForChat: (state, action) => {
      state.campaignInfoForChat = action.payload;
    },
    setAllowChat: (state, action) => {
      state.allowChat = action.payload;
    },
    setIsProductChat: (state, action) => {
      state.isProductChat = action.payload;
    },
    setIsbuyerChatHistory: (state, action) => {
      state.isBuyerChatHistory = action.payload;
    },
    setSelectedCampaignProductsChat: (state, action) => {
      state.isSelectedCampaignProductsChat = action.payload;
    },
    receiveNewMessage: (state, action) => {
      const { campaignId, productId } = action.payload;
      if (state.clearedCampaigns?.[campaignId]) {
        delete state.clearedCampaigns[campaignId];
      }

      if (state.clearedProducts?.[campaignId]?.[productId]) {
        delete state.clearedProducts[campaignId][productId];
      }

      state.isLiveMsgNotification.push(action.payload);
    },
    markCampaignAsRead: (state, action) => {
      state.clearedCampaigns[action.payload] = Date.now();
    },

    markProductAsRead: (state, action) => {
      const { campaignId, productId, readAt } = action.payload;

      if (!state.clearedProducts[campaignId]) {
        state.clearedProducts[campaignId] = {};
      }

      state.clearedProducts[campaignId][productId] = readAt;
    },
  },
});

export const {
  setIsChatModal,
  setIsProductInfo,
  setCampaignInfoForChat,
  setAllowChat,
  setIsProductChat,
  setIsbuyerChatHistory,
  setSelectedCampaignProductsChat,
  markCampaignAsRead,
  markProductAsRead,
} = chatCommunicationHandleSlice.actions;

export default chatCommunicationHandleSlice.reducer;
